// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2M_mx","paper":"styles_paper__1FC4m","tabName":"styles_tabName__vQOOf"};